import React, { ReactElement } from 'react';
import { FormattedMessage, unsafeTranslationKey } from 'intl';

import { ButtonTextIcon, ExpandChevron } from 'components/general';
import { SaveNavigationTarget } from '../../../../hooks/useNavigationTarget';
import { useStyles } from './styles';
import useIsMobile from '../../../../hooks/useIsMobile';
import { ProjectNavigationTarget } from '../../../../views/projects/settings';
import { ProjectSetupTranslationKeys } from 'intl/keys';
export interface NavigationTabProps {
  tabTarget: ProjectNavigationTarget;
  currentTarget: ProjectNavigationTarget;
  baseLocation: string;
  setTarget: SaveNavigationTarget;
  setExpanded: React.Dispatch<React.SetStateAction<boolean>>;
  isExpanded: boolean;
}

function matchTabLabelIdByTarget(target: ProjectNavigationTarget): string {
  switch (target) {
    case ProjectNavigationTarget.generalProjectData:
      return ProjectSetupTranslationKeys.settingsNavigationGeneralProjectData;
    case ProjectNavigationTarget.fieldValues:
      return ProjectSetupTranslationKeys.settingsNavigationFieldValues;
    case ProjectNavigationTarget.projectStructure:
      return ProjectSetupTranslationKeys.settingsNavigationProjectStructure;
    case ProjectNavigationTarget.fieldVisibility:
      return ProjectSetupTranslationKeys.settingsNavigationFieldVisibility;
    case ProjectNavigationTarget.workflowConfiguration:
      return ProjectSetupTranslationKeys.settingsNavigationWorkflowConfiguration;
    case ProjectNavigationTarget.organizationData:
      return ProjectSetupTranslationKeys.settingsNavigationOrganizationData;
  }
}

export function NavigationTab(props: NavigationTabProps): ReactElement {
  const isMobile = useIsMobile();
  const { currentTarget, tabTarget, isExpanded, setExpanded, setTarget } =
    props;
  const isCurrentTab = currentTarget === tabTarget;

  const classes = useStyles({
    isMobile,
    isCurrentTab,
    isExpanded: props.isExpanded,
  });

  return (
    <ButtonTextIcon
      style={{ zIndex: 2 }}
      key={tabTarget}
      aria-label={tabTarget}
      onClick={() => {
        if (isMobile) {
          if (!isExpanded) {
            return setExpanded(true);
          }
          setExpanded(false);
        }
        setTarget(tabTarget);
      }}
      data-qa={`${tabTarget}-button`}
      className={classes.tab}
    >
      <FormattedMessage id={unsafeTranslationKey(matchTabLabelIdByTarget(tabTarget))} />
      <span className={classes.icon}>
        {isMobile && isCurrentTab && (
          <ExpandChevron expanded={isExpanded} />
        )}
      </span>
    </ButtonTextIcon>
  );
}
